// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB58-PWrMU1KBFDnlSOEaX4QjX8Y3a0KDg",
  authDomain: "demodb-36c39.firebaseapp.com",
  databaseURL: "https://demodb-36c39-default-rtdb.firebaseio.com",
  projectId: "demodb-36c39",
  storageBucket: "demodb-36c39.appspot.com",
  messagingSenderId: "494706495857",
  appId: "1:494706495857:web:c0a5c1b1201c8a21dbe6d0",
  measurementId: "G-CGNBLZ6BMF",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app); // Initialize Realtime Database

export { db, ref, onValue };
